import { gql } from "@apollo/client";

export const GET_MATERIAL_NAME_PAGINATION = gql`
  query GetMaterialNamePagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $keyword: String
    $isUse: Boolean
    $categoryId: ID
  ) {
    getMaterialNamePagination(
      page: $page
      limit: $limit
      pagination: $pagination
      keyword: $keyword
      isUse: $isUse
      categoryId: $categoryId
    ) {
      data {
        _id
        materialKhName
        materialEnName
        categoryId {
          _id
          categoryKhName
          categoryEnName
        }
        groupId {
          _id
          groupKhName
          groupEnName
        }
        isUse
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const CREATE_MATERIAL_NAME = gql`
  mutation CreateMaterialName($input: MaterialNameInput) {
    createMaterialName(input: $input) {
      message {
        messageEn
        messageKh
      }
      status
    }
  }
`;

export const UPDATE_MATERIAL_NAME_IS_USE = gql`
  mutation UpdateMaterialNameIsUse($id: ID!, $isUse: Boolean) {
    updateMaterialNameIsUse(_id: $id, isUse: $isUse) {
      message {
        messageEn
        messageKh
      }
      status
    }
  }
`;

export const UPDATE_MATERIAL_NAME = gql`
  mutation UpdateMaterialName($id: ID!, $input: MaterialNameInput) {
    updateMaterialName(_id: $id, input: $input) {
      message {
        messageEn
        messageKh
      }
      status
    }
  }
`;

export const DELETE_MATERIAL_NAME = gql`
  mutation DeleteMaterialName($id: ID!) {
    deleteMaterialName(_id: $id) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;
